import React from 'react';
import { Link } from "@mui/material";
import { Link as RouterLink, useLocation } from "react-router-dom";

interface NavLinkProps {
    name: string;
    href: string;
}

const NavLink = (props: NavLinkProps) => {
    const { pathname } = useLocation();
    const isActive = pathname === props.href || (props.href !== "/" && pathname.startsWith(props.href));

    return (
        <Link
            component={RouterLink}
            to={props.href}
            color={isActive ? "primary.main" : "text.primary"}
            underline="none"
            sx={{
                fontWeight: 500,
                fontSize: "0.9rem",
                transition: "color 0.2s ease",
                "&:hover": { color: "primary.main" },
            }}
        >
            {props.name}
        </Link>
    );
};

export default NavLink;
